import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';


const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';
declare var require: (filename: string) => any;
var BigNumber2100 = require('bignumber.js');

BigNumber2100.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});
const stepsList = [
  /*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['705'] }
];

const tableStructure = [
  { id: 'pagador', title: 'Pagador' },
  { id: 'origen', title: 'Origen información' },
  { id: 'conceptoNombre', title: 'Concepto' },
  { id: 'rentaNombre', title: 'Tipo de renta' },
  { id: 'valor', title: 'Valor' },
];


class Form1 {
  id: number;
  pagador: string;
  origen: string;
  concepto: string;
  conceptoNombre: string;
  tipoRenta: string;
  rentaNombre: string;
  valor: string;
  seccionOrigen: string;
  deshabilitarAcci: boolean;
  suma699: string;
  reportante: string;
  suma699AFC: string;
  suma699Pension: string;
  suma699Cesantias: string;
  valorLimExe: string;
  valorOri_354: string;
  rent1Asal702: string = "0";
  rent2Indp703: string = "0";
  rent3Capt704: string = "0";
  rent4NOla733: string = "0";
  rentPen1Asal706: string = "0";
  rentPen2Indp729: string = "0";
  rentPen3Capt730: string = "0";
  rentPen4NOla731: string = "0";
}

class ArticulosDominio {
  valor: number;
  nombre: string;
  mostrar: boolean;
}

@Component({
  selector: 'app-beneficios-rentas-exentas-de-impuesto-modal',
  templateUrl: './beneficios-rentas-exentas-de-impuesto-modal.component.html',
  styleUrls: ['./beneficios-rentas-exentas-de-impuesto-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class BeneficiosRentasExentasDeImpuestoModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public conceptosRentasExentas: ArticulosDominio[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;
  listaTipoRenta: any = [];

  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  uvt: string;

  rangos = [
    { desde: 0, hasta: 350, tarifa: '1' },
    { desde: 351, hasta: 410, tarifa: '0.90' },
    { desde: 411, hasta: 470, tarifa: '0.80' },
    { desde: 471, hasta: 530, tarifa: '0.60' },
    { desde: 531, hasta: 590, tarifa: '0.40' },
    { desde: 591, hasta: 650, tarifa: '0.20' }
  ];
  //conceptosRentasExentasOriginal: ArticulosDominio[];

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<BeneficiosRentasExentasDeImpuestoModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.obtenerEliminarDataTrabInd();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();    
    this.validateShowSave();
    this.actualizarDataTrabajadorAsal_Indep();
    


    this.listaTipoRenta.forEach(item => {
      item.mostrar = false;
    });

    
    //this.conceptosRentasExentas = this.conceptosRentasExentas.filter(item => Number(item.valor) != 7 && Number(item.valor) != 8 && Number(item.valor) != 4);
    this.conceptosRentasExentas.sort((a, b) => Number(a.valor) - Number(b.valor));
    console.log("Lista orden= ",this.conceptosRentasExentas);
    
    this.conceptosRentasExentas.forEach(item => {
      item.mostrar = true;
    });
    this.reloadSelConcepto2();
    /* this.conceptosRentasExentas = this.conceptosRentasExentas.filter(item => item.valor != 9);
    console.log("Sin Item 9= ",this.conceptosRentasExentas); */

    /*       this.model.doc.cuerpo.cs_id_702 = "0";
          this.model.doc.cuerpo.cs_id_703 = "0";
          this.model.doc.cuerpo.cs_id_704 = "0";
          this.model.doc.cuerpo.cs_id_733 = "0";
    
          this.model.doc.cuerpo.cs_id_706 = "0";
          this.model.doc.cuerpo.cs_id_729 = "0";
          this.model.doc.cuerpo.cs_id_730 = "0";
          this.model.doc.cuerpo.cs_id_731 = "0"; */

    console.log(this.listaTipoRenta);
    console.log("Valor UVT= ", this.uvt);
    console.log("Conceptos REXT",this.conceptosRentasExentas);
    //console.log("Casilla simple Asalariado Limitante AFC 294 = ", this.model.doc.cuerpo.cc_id_294[0].v);
    //console.log("Casilla simple Asalariado Limitante RAIS 295 = ", this.model.doc.cuerpo.cs_id_295);
    //console.log("Casilla simple Asalariado Limitante Pensiones 296 = ", this.model.doc.cuerpo.cc_id_296[0].v);

    /* console.log("Casilla compuesta Asalariado Aportes a Cuentas AFC o AVC  290 = ", this.model.doc.cuerpo.cc_id_290);
    console.log("Casilla compuesta Asalariado Aporte Voluntarios a fondos de pensiones 291 = ", this.model.doc.cuerpo.cc_id_291);
    console.log("Casilla compuesta Asalariado Cesantías parte exenta 298 = ", this.model.doc.cuerpo.cc_id_298);
    console.log("Casilla compuesta Asalariado Cesantías Auxilio Cesantías 285 = ", this.model.doc.cuerpo.cc_id_285);

    //console.log("Casilla simple Independiente Limitante Pensiones 320 = ", this.model.doc.cuerpo.cc_id_320[0].v);
    console.log("Casilla simple Independiente Limitante AFC 319 = ", this.model.doc.cuerpo.cs_id_319);

    console.log("Casilla compuesta Independiente Aporte Voluntarios a fondos de pensiones 314 = ", this.model.doc.cuerpo.cc_id_314);
    console.log("Casilla compuesta Independiente Aportes a Cuentas AFC o AVC  315 = ", this.model.doc.cuerpo.cc_id_315);
    console.log("Casilla compuesta Pension de Jubilacion 354 = ", this.model.doc.cuerpo.cc_id_354);
    console.log("Casilla compuesta Limit Pension Jubilacion 336  = ", this.model.doc.cuerpo.cc_id_363); */

    console.log(this.model);
  }

  protected controlStep(direction: DirectionType): void {

  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.pagador = "";
    this.modelForm.concepto = "0";
    this.modelForm.conceptoNombre = "";
    this.modelForm.tipoRenta = "0";
    this.modelForm.rentaNombre = "";
    this.modelForm.valor = "0";
    this.modelForm.origen = "";
    this.modelForm.seccionOrigen = "";
    this.modelForm.suma699AFC = "0";
    this.modelForm.suma699Pension = "0";
    this.modelForm.suma699Cesantias = "0";
    this.modelForm.reportante = "";
    this.modelForm.valorLimExe = "0";
    this.modelForm.valorOri_354 = "0";

    /*  this.modelForm.rent1Asal702 = "0";
     this.modelForm.rent2Indp703 = "0";
     this.modelForm.rent3Capt704 = "0";
     this.modelForm.rent4NOla733 = "0";
 
     this.modelForm.rentPen1Asal706 = "0";
     this.modelForm.rentPen2Indp729 = "0";
     this.modelForm.rentPen3Capt730 = "0";
     this.modelForm.rentPen4NOla731 = "0";
      */

  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_695 == undefined) {

      this.model.doc.cuerpo.cc_id_695 = []; //pagador 709 -- 695
      this.model.doc.cuerpo.cc_id_696 = []; //origen  710 -- 696
      this.model.doc.cuerpo.cc_id_697 = []; //concepto 711 -- 697
      this.model.doc.cuerpo.cc_id_698 = []; //tipoRenta 712 -- 698
      this.model.doc.cuerpo.cc_id_699 = []; //valor 713 -- 699      
      this.model.doc.cuerpo.cc_id_701 = []; //seccionOrigen  721 -- 701      
      this.model.doc.cuerpo.cs_id_700 = "0";//total  714 -- 700

      /*      this.model.doc.cuerpo.cs_id_702 = "0";
           this.model.doc.cuerpo.cs_id_703 = "0";
           this.model.doc.cuerpo.cs_id_704 = "0";
           this.model.doc.cuerpo.cs_id_733 = "0";
     
           this.model.doc.cuerpo.cs_id_706 = "0";
           this.model.doc.cuerpo.cs_id_729 = "0";
           this.model.doc.cuerpo.cs_id_730 = "0";
           this.model.doc.cuerpo.cs_id_731 = "0"; */

      //= this.dutilidades.deshacerFormatoMoneda(this.model.doc.cuerpo.cc_id_294[0].v);
      /* this.model.doc.cuerpo.cc_id_297 = [];
      this.model.doc.cuerpo.cc_id_298 = [];
      this.model.doc.cuerpo.cs_id_294 = "0"; 
      this.model.doc.cuerpo.cs_id_295 = "0";
      this.model.doc.cuerpo.cs_id_296 = "0"; */

    }
  }

  protected reloadSelConcepto() {
    this.listaTipoRenta = this.listaTipoRenta.filter(item => item.valor !== "6");
    if (this.modelForm.concepto == "1" || this.modelForm.concepto == "2" || this.modelForm.concepto == "3" 
      || this.modelForm.concepto == "4" || this.modelForm.concepto == "9") {

      for (let i = 0; i < this.listaTipoRenta.length; i++) {
        if (i == 0) {
          this.listaTipoRenta[i].mostrar = true;
        } else {
          this.listaTipoRenta[i].mostrar = false;
        }

      }
    } else if (this.modelForm.concepto == "5" || this.modelForm.concepto == "6") {
      for (let i = 0; i < this.listaTipoRenta.length; i++) {
        if (i == 4) {
          this.listaTipoRenta[i].mostrar = true;
        } else {
          this.listaTipoRenta[i].mostrar = false;
        }
      }

    } else if (this.modelForm.concepto == "10") {
      for (let i = 0; i < this.listaTipoRenta.length; i++) {
        if (i == 2 || i == 3 ) {
          this.listaTipoRenta[i].mostrar = true;
        } else {
          this.listaTipoRenta[i].mostrar = false;
        }
      }
    }     

  }
  
  protected reloadSelConcepto2(){
  if (this.modelForm.seccionOrigen != "I5") {
      if (this.conceptosRentasExentas.length > 0) {
        for (let i = 0; i < this.conceptosRentasExentas.length; i++) {
          if (i == 3 || i == 6 || i == 7 || i == 8) {
            this.conceptosRentasExentas[i].mostrar = false;          
          } else {
            this.conceptosRentasExentas[i].mostrar = true;
          }
        } 
      }
  }else{
    if (this.conceptosRentasExentas.length > 0) {
      for (let i = 0; i < this.conceptosRentasExentas.length; i++) {
        if (i == 4 || i == 5 ) {
          this.conceptosRentasExentas[i].mostrar = true;          
        } else {
          this.conceptosRentasExentas[i].mostrar = false;
        }
      } 
    }

  }    
  }  
  

  actualizarDataTrabajadorAsal_Indep() {

    // Asalariado
    //this.dataSourceBody = [];
    let indexModel = this.model.doc.cuerpo.cc_id_695.length;
    if ((this.model.doc.cuerpo.cc_id_290 != undefined && this.model.doc.cuerpo.cc_id_290 != null)
      && (this.model.doc.cuerpo.cc_id_291 != undefined && this.model.doc.cuerpo.cc_id_291 != null)) {

      /* const posicionesAporVolAFCoAVCyPension = this.model.doc.cuerpo.cc_id_290
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1); */
        
        let  posiciones=[];
        for (let i = 0; i < this.model.doc.cuerpo.cc_id_290.length; i++){
          if((this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cc_id_290[i].v, "0", false)) || 
          (this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cc_id_291[i].v, "0", false)))
            posiciones.push(i);
        }  
        
      if (posiciones.length > 0) {
        this.inicializeForm();
        for (let i = 0; i < posiciones.length; i++) {
          const indexAporVolAFCoAVCyPension = posiciones[i];
          //const existeValor = this.model.doc.cuerpo.cc_id_303.filter(item => item.v === "1").map(item => item.it);
          //const existeValor = this.model.doc.cuerpo.cc_id_695.some(item => item.v === this.model.doc.cuerpo.cc_id_277[indexAporVolAFCoAVCyPension].v);
          

            this.modelForm.id = indexModel;
            this.modelForm.pagador = this.model.doc.cuerpo.cc_id_277[indexAporVolAFCoAVCyPension].v;
            this.modelForm.origen = this.model.doc.cuerpo.cc_id_278[indexAporVolAFCoAVCyPension].v;
            this.modelForm.tipoRenta = "1";
            if (this.listaTipoRenta && this.listaTipoRenta.length > 0) {
              this.modelForm.rentaNombre = this.listaTipoRenta.find(item => item.valor.toString() == this.modelForm.tipoRenta).nombre;
            }
            let valorAFC290 = this.model.doc.cuerpo.cc_id_290[indexAporVolAFCoAVCyPension].v;
            let valorPen291 = this.model.doc.cuerpo.cc_id_291[indexAporVolAFCoAVCyPension].v;
            this.modelForm.valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valorAFC290, valorPen291);
            this.modelForm.concepto = "10";
            if (this.conceptosRentasExentas && this.conceptosRentasExentas.length > 0) {
              this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor.toString() == this.modelForm.concepto).nombre;
            }
            this.modelForm.seccionOrigen = "I1";
            this.modelForm.deshabilitarAcci = true;

            console.log(this.modelForm);
            console.log(this.conceptosRentasExentas);
            this.valExenAportVolAFCoAVCyPensionAsalariado();
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;

          
        }
      }
      this.operacionCs700();
      this.distribucionRentasExentasImpAFC();

    };

    
    if ((this.model.doc.cuerpo.cc_id_285 != undefined
      && this.model.doc.cuerpo.cc_id_285 != null) && (this.model.doc.cuerpo.cc_id_298 != undefined
        && this.model.doc.cuerpo.cc_id_298 != null)) {

      const posicionesCesantias = this.model.doc.cuerpo.cc_id_285
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);

      if (posicionesCesantias.length > 0) {
        this.inicializeForm();

        for (let i = 0; i < posicionesCesantias.length; i++) {
          const indexPosicionesCesantias = posicionesCesantias[i];
          //const existeValor = this.model.doc.cuerpo.cc_id_695.some(item => item.v === this.model.doc.cuerpo.cc_id_277[indexPosicionesCesantias].v);
          
            this.modelForm.id = indexModel;
            this.modelForm.pagador = this.model.doc.cuerpo.cc_id_277[indexPosicionesCesantias].v;
            this.modelForm.origen = this.model.doc.cuerpo.cc_id_278[indexPosicionesCesantias].v;
            this.modelForm.tipoRenta = "1";//this.model.doc.cuerpo.cc_id_303[indexLimitanteAporVolPensiones].v;
            if (this.listaTipoRenta && this.listaTipoRenta.length > 0) {
              this.modelForm.rentaNombre = this.listaTipoRenta.find(item => item.valor.toString() == this.modelForm.tipoRenta).nombre;
            }
            //this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta)].nombre;
            this.modelForm.valor = this.model.doc.cuerpo.cc_id_285[indexPosicionesCesantias].v;
            this.modelForm.valorLimExe = this.model.doc.cuerpo.cc_id_298[indexPosicionesCesantias].v;
            this.modelForm.concepto = "4";
            if (this.conceptosRentasExentas && this.conceptosRentasExentas.length > 0) {
              this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor.toString() == this.modelForm.concepto).nombre;
            }
            this.modelForm.seccionOrigen = "I1";
            this.modelForm.deshabilitarAcci = true;

            console.log(this.modelForm);
            console.log(this.conceptosRentasExentas);
            this.valExentoCesantiasAsalariado();
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            //this.addToModeloDesdeForm();
            this.inicializeForm();
            indexModel++;
          
        }
      }
      this.operacionCs700();
    };

 
    if ((this.model.doc.cuerpo.cc_id_314 != undefined && this.model.doc.cuerpo.cc_id_314 != null) 
      && (this.model.doc.cuerpo.cc_id_315 != undefined && this.model.doc.cuerpo.cc_id_315 != null)
      && (this.model.doc.cuerpo.cc_id_319 != undefined && this.model.doc.cuerpo.cc_id_319 != null)) {
      
      let  posiciones=[];
      for (let i = 0; i < this.model.doc.cuerpo.cc_id_314.length; i++){
        if(this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cc_id_314[i].v, "0", false)|| 
        this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cc_id_315[i].v, "0", false ))
          posiciones.push(i);
      }  
          
      if (posiciones) {
      
        
        this.inicializeForm();
        for (let i = 0; i < posiciones.length; i++) {
          const indexAporVolIndAFCoAVCPen = posiciones[i];
          //const existeValor = this.model.doc.cuerpo.cc_id_303.filter(item => item.v === "2").map(item => item.it);
         // const existeValor = this.model.doc.cuerpo.cc_id_695.some(item => item.v === this.model.doc.cuerpo.cc_id_309[indexAporVolIndAFCoAVCPen].v);
          

            this.modelForm.id = indexModel;
            this.modelForm.pagador = this.model.doc.cuerpo.cc_id_309[indexAporVolIndAFCoAVCPen].v;
            this.modelForm.origen = this.model.doc.cuerpo.cc_id_302[indexAporVolIndAFCoAVCPen].v;
            this.modelForm.tipoRenta = this.model.doc.cuerpo.cc_id_303[indexAporVolIndAFCoAVCPen].v;
            if (this.listaTipoRenta && this.listaTipoRenta.length > 0) {
              this.modelForm.rentaNombre = this.listaTipoRenta.find(item => item.valor.toString() == this.modelForm.tipoRenta).nombre;
            }
            //this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta)].nombre;
            let valorPen314 = this.model.doc.cuerpo.cc_id_314[indexAporVolIndAFCoAVCPen].v;
            let valorAFC315 = this.model.doc.cuerpo.cc_id_315[indexAporVolIndAFCoAVCPen].v;
            this.modelForm.valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valorPen314, valorAFC315);
            this.modelForm.valorLimExe = this.model.doc.cuerpo.cc_id_319[indexAporVolIndAFCoAVCPen].v;
            this.modelForm.concepto = "10";
            if (this.conceptosRentasExentas && this.conceptosRentasExentas.length > 0) {
              this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor.toString() == this.modelForm.concepto).nombre;
            }
            this.modelForm.seccionOrigen = "I2";
            this.modelForm.deshabilitarAcci = true;

            console.log(this.modelForm);
            console.log(this.conceptosRentasExentas);
            this.valExenAporteAFCIndependiente();
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            //this.addToModeloDesdeForm();
            this.inicializeForm();
            indexModel++;
          

        }

      }
      this.operacionCs700();
      this.distribucionRentasExentasImpAFC();
      //this.operacionCs700Desde699();   
    };
    // Ingresos Pensión de Jubilación          
    if ((this.model.doc.cuerpo.cc_id_354 != undefined
      && this.model.doc.cuerpo.cc_id_354 != null) && (this.model.doc.cuerpo.cc_id_363 != undefined
        && this.model.doc.cuerpo.cc_id_363 != null)) {

      const posicionesIngresosPensionJubi = this.model.doc.cuerpo.cc_id_354
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);

      if (posicionesIngresosPensionJubi.length > 0) {
        this.inicializeForm();

        for (let i = 0; i < posicionesIngresosPensionJubi.length; i++) {
          const indexIngresosPensionJubi = posicionesIngresosPensionJubi[i];
          //const existeValor = this.model.doc.cuerpo.cc_id_303.filter(item => item.v === "2").map(item => item.it);
          //const existeValor = this.model.doc.cuerpo.cc_id_695.some(item => item.v === this.model.doc.cuerpo.cc_id_351[indexIngresosPensionJubi].v);
        
            this.modelForm.id = indexModel;
            this.modelForm.pagador = this.model.doc.cuerpo.cc_id_351[indexIngresosPensionJubi].v;
            this.modelForm.origen = this.model.doc.cuerpo.cc_id_352[indexIngresosPensionJubi].v;
            this.modelForm.tipoRenta = "5";
            if (this.listaTipoRenta && this.listaTipoRenta.length > 0) {
              this.modelForm.rentaNombre = this.listaTipoRenta.find(item => item.valor.toString() == this.modelForm.tipoRenta).nombre;
            }
            this.modelForm.valor = this.model.doc.cuerpo.cc_id_354[indexIngresosPensionJubi].v;
            this.modelForm.valorOri_354 = this.model.doc.cuerpo.cc_id_354[indexIngresosPensionJubi].v;
            this.modelForm.valorLimExe = this.model.doc.cuerpo.cc_id_363[indexIngresosPensionJubi].v;
            this.modelForm.concepto = "6";
            if (this.conceptosRentasExentas && this.conceptosRentasExentas.length > 0) {
              this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor.toString() == this.modelForm.concepto).nombre;
            }

            this.modelForm.seccionOrigen = "I5";
            this.modelForm.deshabilitarAcci = false;
            this.valExentoPensioJubi1997();
            console.log(this.modelForm);
            console.log(this.conceptosRentasExentas);
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          

        }

      }
      this.operacionCs700();
      //this.operacionCs700Desde699();   
    };
    // 25% Asalariados           
    if (this.model.doc.cuerpo.cc_id_297 != undefined
      && this.model.doc.cuerpo.cc_id_297 != null) {

      const posicionesIngresosPension = this.model.doc.cuerpo.cc_id_297
        .map((item, index) => (parseInt(item.v, 10) > 0 ? index : -1))
        .filter(index => index !== -1);

      if (posicionesIngresosPension.length > 0) {
        this.inicializeForm();

        for (let i = 0; i < posicionesIngresosPension.length; i++) {
          //const indexIngresosPension = posicionesIngresosPension[i];
          //const existeValor = this.model.doc.cuerpo.cc_id_303.filter(item => item.v === "2").map(item => item.it);
          //const existeValor = this.model.doc.cuerpo.cc_id_695.some(item => item.v === this.model.doc.cuerpo.cc_id_277[indexIngresosPension].v);
        
            if(i>0)break;
            this.modelForm.id = indexModel;
            this.modelForm.pagador = "Rentas trabajo";//this.model.doc.cuerpo.cc_id_277[indexIngresosPension].v;
            this.modelForm.origen = "2";//this.model.doc.cuerpo.cc_id_278[indexIngresosPension].v;
            this.modelForm.tipoRenta = "2";
            if (this.listaTipoRenta && this.listaTipoRenta.length > 0) {
              this.modelForm.rentaNombre = this.listaTipoRenta.find(item => item.valor.toString() == this.modelForm.tipoRenta).nombre;
            }
            //this.modelForm.valor = this.model.doc.cuerpo.cc_id_297[indexIngresosPension].v;
            this.modelForm.valor = this.model.doc.cuerpo.cc_id_297[0].v;
            this.modelForm.concepto = "9";
            if (this.conceptosRentasExentas && this.conceptosRentasExentas.length > 0) {
              this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor.toString() == this.modelForm.concepto).nombre;
            }
            this.modelForm.seccionOrigen = "I1";
            this.modelForm.deshabilitarAcci = true;

            console.log(this.modelForm);
            console.log(this.conceptosRentasExentas);
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
        

        }

      }
      this.operacionCs700();
      //this.operacionCs700Desde699();   
    };
  }

  distribucionRentasExentasImpAFC() {

    let suma702 = "0";
    let suma703 = "0";
    let suma704 = "0";
    let suma706 = "0";
    let suma732 = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      if (this.dataSourceBody[i].tipoRenta == "1" && this.dataSourceBody[i].concepto == "10") {
        suma702 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma702);
      }
      else if (this.dataSourceBody[i].tipoRenta == "2" && this.dataSourceBody[i].concepto == "10") {
        suma703 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma703);
      }
      else if (this.dataSourceBody[i].tipoRenta == "3" && this.dataSourceBody[i].concepto == "10") {
        suma704 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma704);
      }
      else if (this.dataSourceBody[i].tipoRenta == "4" && this.dataSourceBody[i].concepto == "10") {
        suma706 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma706);
      }
      else if (this.dataSourceBody[i].tipoRenta == "1" && this.dataSourceBody[i].concepto == "4") {
        suma732 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma732);
      }
    }
    this.model.doc.cuerpo.cs_id_702 = suma702? suma702:"0";
    this.model.doc.cuerpo.cs_id_703 = suma703? suma703:"0";
    this.model.doc.cuerpo.cs_id_704 = suma704? suma704:"0";
    this.model.doc.cuerpo.cs_id_706 = suma706? suma706:"0";
    this.model.doc.cuerpo.cs_id_732 = suma732? suma732:"0";


    /* for (let i = 0; i < this.modelForm.id; i++) {
      if (this.modelForm[i].tipoRenta == "1" && this.modelForm[i].concepto == "10") {
        suma702 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma702);
      } */

    
    const rent1Asal702 = this.model.doc.cuerpo.cs_id_702;
    const rent2Indp703 = this.model.doc.cuerpo.cs_id_703;
    const rent3Capt704 = this.model.doc.cuerpo.cs_id_704;
    const rent4NOla706 = this.model.doc.cuerpo.cs_id_706;
    const limtAFC3800UVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, "3800");

    let valorTotalAFC = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, rent1Asal702, rent2Indp703);
    valorTotalAFC = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, rent3Capt704, valorTotalAFC);
    valorTotalAFC = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, rent4NOla706, valorTotalAFC);
    let valorAFCLimt = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorTotalAFC, limtAFC3800UVT) ? valorTotalAFC : limtAFC3800UVT;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, rent1Asal702, valorAFCLimt)) {
      this.model.doc.cuerpo.cs_id_702 = rent1Asal702;
      valorAFCLimt = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valorAFCLimt, rent1Asal702);
    } else {
      this.model.doc.cuerpo.cs_id_702 = valorAFCLimt;
      valorAFCLimt = "0";
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, rent2Indp703, valorAFCLimt)) {
      this.model.doc.cuerpo.cs_id_703 = rent2Indp703;
      valorAFCLimt = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valorAFCLimt, rent2Indp703);
    } else {
      this.model.doc.cuerpo.cs_id_703 = valorAFCLimt;
      valorAFCLimt = "0";
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, rent3Capt704, valorAFCLimt)) {
      this.model.doc.cuerpo.cs_id_704 = rent3Capt704;
      valorAFCLimt = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valorAFCLimt, rent3Capt704);
    } else {
      this.model.doc.cuerpo.cs_id_704 = valorAFCLimt;
      valorAFCLimt = "0";
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, rent4NOla706, valorAFCLimt)) {
      this.model.doc.cuerpo.cs_id_706 = rent4NOla706;
      valorAFCLimt = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valorAFCLimt, rent4NOla706);
    } else {
      this.model.doc.cuerpo.cs_id_706 = valorAFCLimt;
      valorAFCLimt = "0";
    }
    console.log("Renta AFC Pen 1= ", this.model.doc.cuerpo.cs_id_702);
    console.log("Renta AFC Pen 2= ", this.model.doc.cuerpo.cs_id_703);
    console.log("Renta AFC Pen 3= ", this.model.doc.cuerpo.cs_id_704);
    console.log("Renta AFC Pen 4= ", this.model.doc.cuerpo.cs_id_706);
  }

  
  // Pensión de jubilación Antes y Después 1997 * "5=Rentas Pensiones" de Ingreso pensiones
  valExentoPensioJubi1997() {
    const valorOriginal = this.modelForm.valorOri_354; //Casilla Compuesta 354
    const valor = this.modelForm.valor; //Casilla Compuesta 354       
    const tipoRenta = this.modelForm.tipoRenta;
    const concepto = this.modelForm.concepto;
    const valorLimExe = this.modelForm.valorLimExe; // Casilla Compuesta 363    

    if ((tipoRenta == "5") && (concepto == "6")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, valorLimExe)) {
        this.modelForm.valor = valor;
      } else {
        this.modelForm.valor = valorLimExe;
      }
    } else if ((tipoRenta == "5") && (concepto == "5")) {
      this.modelForm.valor = valorOriginal;
    }
  }


  //******** Inicio Validaciones Aportes a cuentas AFC  **********
  // Asalariado


  valExenAportVolAFCoAVCyPensionAsalariado() {

    const valor = this.modelForm.valor; //Casilla Compuesta 290 + 921      
    const tipoRenta = this.modelForm.tipoRenta;
    const concepto = this.modelForm.concepto;
    if (this.model.doc.cuerpo.cc_id_294 != undefined && this.model.doc.cuerpo.cc_id_294 != null) {
      const valorLimExe = this.dutilidades.deshacerFormatoMoneda(this.model.doc.cuerpo.cc_id_294[0].v); // Casilla compuesta Limite AFC 294    
      if ((tipoRenta == "1" && concepto == "10")) {
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, valorLimExe)) {
          this.modelForm.valor = valor;
        } else {
          this.modelForm.valor = valorLimExe;
        }       
      }
    } else {
      this.modelForm.valor = valor;
    }
  }

  valExenAporteAFCIndependiente() {

    const valor = this.modelForm.valor; //Casilla Compuesta 315       
    const tipoRenta = this.modelForm.tipoRenta;
    const concepto = this.modelForm.concepto;
    const valorLimExe = this.modelForm.valorLimExe; // Casilla compuesta Limite AFC 319    

    if ((tipoRenta == "2" && concepto == "10")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, valorLimExe)) {
        this.modelForm.valor = valor;
      } else {
        this.modelForm.valor = valorLimExe;
      }
      //this.model.doc.cuerpo.cs_id_703 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_703, this.modelForm.valor);
    } else {
      this.modelForm.valor = valor;
    }
  }

  //******************** INICIO Auxilio e intereses de cesantía y intereses sobre cesantías */
  // Asalariado
  valExentoCesantiasAsalariado() {

    const valor = this.modelForm.valor; //Casilla Compuesta 285       
    const tipoRenta = this.modelForm.tipoRenta;
    const concepto = this.modelForm.concepto;
    const valorLimExe = this.modelForm.valorLimExe; // Casilla Compuesta 298

    if ((tipoRenta == "1") && (concepto == "4")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valor, valorLimExe)) {
        this.modelForm.valor = valor;
      } else {
        this.modelForm.valor = valorLimExe;
      }
      //this.model.doc.cuerpo.cs_id_732 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_732, this.modelForm.valor);
    } else {
      this.modelForm.valor = valor;
    }
  }

  obtenerEliminarDataTrabInd(){
    if(this.model.doc.cuerpo.cc_id_701 != undefined 
      && this.model.doc.cuerpo.cc_id_701 != null){

        const posicionesTrabInd = this.model.doc.cuerpo.cc_id_701.reduce((acc, item, index) => {
          if (item.v != '') {
              acc.push(index);
          }
          return acc;
      }, []);

      posicionesTrabInd.sort((a, b) => b - a).forEach(index => {
        this.deleteOnModel(index)
      });
    }
  }
  
 
  public operacionCs700() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valor, suma);
    }
    if (suma)
      this.model.doc.cuerpo.cs_id_700 = suma;
    else
      this.model.doc.cuerpo.cs_id_700 = '0';

  }


  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    if (this.model.doc.cuerpo.cc_id_695 != undefined && this.model.doc.cuerpo.cc_id_695 != null) {
      for (let i = 0; i < this.model.doc.cuerpo.cc_id_695.length; i++) {
        this.modelForm.id = i;
        this.modelForm.pagador = this.model.doc.cuerpo.cc_id_695[i].v;
        this.modelForm.origen = this.model.doc.cuerpo.cc_id_696[i].v;
        this.modelForm.concepto = this.model.doc.cuerpo.cc_id_697[i].v;
        if (this.model.doc.cuerpo.cc_id_697[i] && this.conceptosRentasExentas[this.model.doc.cuerpo.cc_id_697[i].v - 1])
          this.modelForm.conceptoNombre = this.conceptosRentasExentas[this.model.doc.cuerpo.cc_id_697[i].v - 1].nombre;
        this.modelForm.tipoRenta = this.model.doc.cuerpo.cc_id_698[i].v;
        if (this.model.doc.cuerpo.cc_id_698[i] && this.listaTipoRenta[this.model.doc.cuerpo.cc_id_698[i].v - 1])
          this.modelForm.rentaNombre = this.listaTipoRenta[this.model.doc.cuerpo.cc_id_698[i].v - 1].nombre;
        this.modelForm.valor = this.model.doc.cuerpo.cc_id_699[i].v;
        this.modelForm.seccionOrigen = this.model.doc.cuerpo.cc_id_701[i].v;
        this.modelForm.deshabilitarAcci = this.modelForm.seccionOrigen != "" ? true : false;
        this.dataSourceBody.push(this.modelForm);
        this.inicializeForm();
      }
    }
  }

  protected initializeTablaDesdeSugerida() {
    let indexModel = this.model.doc.cuerpo.cc_id_695.length;
    if (indexModel == 0) {
      const fieldsRecovery = ['VAR_2230'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);

      if (resData) {
        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {

            this.modelForm.id = indexModel;
            this.modelForm.pagador = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.tipoRenta = "1";
            this.modelForm.rentaNombre = this.listaTipoRenta['1'].nombre;
            this.modelForm.concepto = "7";
            this.modelForm.conceptoNombre = this.conceptosRentasExentas['7'].nombre;
            this.modelForm.valor = this.dutilidades.redondearValorMoneda(String(resData[i].item.value[j]), true);
            if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelForm.valor, "0")) {
              this.modelForm.valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valor, "-1", true);
            }
            this.modelForm.origen = "0";
            this.modelForm.deshabilitarAcci = false;
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          }

        }
      }
    }
    this.operacionCs700();
  }

  public editModeloDesdeForm() {

    this.model.doc.cuerpo.cc_id_695[this.modelForm.id].v = this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_696[this.modelForm.id].v = this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_697[this.modelForm.id].v = this.modelForm.concepto.toString();
    this.model.doc.cuerpo.cc_id_698[this.modelForm.id].v = this.modelForm.tipoRenta.toString();
    this.model.doc.cuerpo.cc_id_699[this.modelForm.id].v = this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_701[this.modelForm.id].v = this.modelForm.seccionOrigen.toString();

  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_695.push({ it: i, v: this.modelForm.pagador });
    this.model.doc.cuerpo.cc_id_696.push({ it: i, v: this.modelForm.origen.toString() });
    this.model.doc.cuerpo.cc_id_697.push({ it: i, v: this.modelForm.concepto.toString() });
    this.model.doc.cuerpo.cc_id_698.push({ it: i, v: this.modelForm.tipoRenta.toString() });
    this.model.doc.cuerpo.cc_id_699.push({ it: i, v: this.modelForm.valor.toString() });
    this.model.doc.cuerpo.cc_id_701.push({ it: i, v: this.modelForm.seccionOrigen.toString() });

  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_695.splice(index, 1);
    this.model.doc.cuerpo.cc_id_696.splice(index, 1);
    this.model.doc.cuerpo.cc_id_697.splice(index, 1);
    this.model.doc.cuerpo.cc_id_698.splice(index, 1);
    this.model.doc.cuerpo.cc_id_699.splice(index, 1);
    this.model.doc.cuerpo.cc_id_701.splice(index, 1);


    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_695.length; i++) {
      this.model.doc.cuerpo.cc_id_695[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_696[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_697[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_698[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_699[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_701[i].it = i + 1;

    }
  }

  public validateFormCompleted(): boolean {
    return this.modelForm.pagador == undefined || this.modelForm.pagador == null || this.modelForm.pagador.trim() == "" ||
      this.modelForm.tipoRenta == undefined || this.modelForm.tipoRenta == null || this.modelForm.tipoRenta == "0" ||
      this.modelForm.concepto == undefined || this.modelForm.concepto == null || this.modelForm.concepto == "0" ||
      this.modelForm.valor == undefined || this.modelForm.valor == null ||
      this.modelForm.origen == undefined || this.modelForm.origen == null
  }

  public redondearFormData() {
    this.modelForm.valor = this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(), true);
    //this.modelForm.limInterVivi=this.dutilidades.redondearValorMoneda(this.modelForm.limInterVivi.toString(),true);
    //this.modelForm.limMediPrep=this.dutilidades.redondearValorMoneda(this.modelForm.limMediPrep.toString(),true);
    /*     this.modelForm.limDepen=this.dutilidades.redondearValorMoneda(this.modelForm.limDepen.toString(),true); */
    //this.modelForm.lim4xmil=this.dutilidades.redondearValorMoneda(this.modelForm.lim4xmil.toString(),true);
    //this.modelForm.limInterIce=this.dutilidades.redondearValorMoneda(this.modelForm.limInterIce.toString(),true);

  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();


  }

  reloadListConceptos() {
    const valorTipoRenta = this.modelForm.tipoRenta;
    /*  1 - Rentas de trabajo sin costo
 2 - Rentas de trabajo con costo
 3 - Rentas de capital
 4 -  Rentas no laborales
 5 - Pensión
 6 - Dividendos
 7 - GO
 
 1 Renta de trabajo sin costo,
 2 Renta de trabajo con costo
 3 Rentas de Capital
 4 Renta no laborales",
 */

    /*Intereses préstamos compra vivienda
    Intereses préstamos  ICETEX
    Medicina prepagada y seguro de salud
    GMF 4 X 1000
    Aportes a Cesantías */

    /*     this.listaConcDeduEspe.forEach(item => {
          item.mostrar = true;
          if((valorTipoRenta=="1" || valorTipoRenta=="2") && item.valor==5){
            item.mostrar = false;
          }else if((valorTipoRenta=="3" || valorTipoRenta=="4") && item.valor==2){
            item.mostrar=false;
          }
    
        }); */

  }

  /*   reloadListTipoRent(){
      const concepto = this.modelForm.concepto;
      this.listaTipoRenta.forEach(item => {
        item.mostrar = false;
        if((concepto=="1" || concepto=="2" || concepto=="4")){
          item.mostrar=true;
        }else if(concepto=="3" && (item.valor==1 || item.valor==2)){
          item.mostrar=true;
        }else if(concepto=="5" && (item.valor==3 || item.valor==4)){
          item.mostrar=true;
        }
      });
        
  
    } */



  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla == this.OPERACION_EDITAR) {

        const existeValor = this.model.doc.cuerpo.cc_id_695.some(item => item.v === this.modelForm.pagador);
        this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta) - 1].nombre;
        /*    this.modelForm.conceptoNombre = this.conceptosRentasExentas[Number(this.modelForm.concepto)-1].nombre;
            if(this.modelForm.seccionOrigen==""){
              if(this.modelForm.origen=="2" || this.modelForm.origen=="1" || (existeValor && this.modelForm.origen=="0")){ //editando contribuyente o editando sugerida
                this.modelForm.origen = this.modelForm.origen=="0" && this.modelForm.origen=="0" ? "1" : this.modelForm.origen;
                this.editModeloDesdeForm();
              }else if(this.modelForm.origen=="0"){ //editando sugerida
                this.modelForm.origen = "1";
                this.modelForm.id = this.model.doc.cuerpo.cc_id_695.length;
                this.addToModeloDesdeForm();
              }
            }else{
              if(existeValor){
                this.editModeloDesdeForm();
              }else{
                this.modelForm.id = this.model.doc.cuerpo.cc_id_695.length;
                this.addToModeloDesdeForm();
              }
            } */
              this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor == Number(this.modelForm.concepto)).nombre;
        //this.modelForm.conceptoNombre = this.conceptosRentasExentas[Number(this.modelForm.concepto) - 1].nombre;
        //this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor.toString() == this.modelForm.concepto).nombre;        
        if (this.modelForm.origen == "0") {
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });

      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_695.length;
        this.modelForm.origen = "2";
        this.modelForm.reportante = "Contribuyente";
        this.modelForm.rentaNombre = this.listaTipoRenta[Number(this.modelForm.tipoRenta) - 1].nombre;
        /* if (this.conceptosRentasExentas && this.conceptosRentasExentas.length > 0) {
          this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor.toString() == this.modelForm.concepto).nombre;
        } */
        this.modelForm.conceptoNombre = this.conceptosRentasExentas.find(item => item.valor == Number(this.modelForm.concepto)).nombre; //[Number(this.modelForm.tipoCompensacion)-1].nombre;
        //this.modelForm.conceptoNombre = this.conceptosRentasExentas[Number(this.modelForm.concepto) - 1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs700();
      this.distribucionRentasExentasImpAFC();
      
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs700();
    this.distribucionRentasExentasImpAFC();
    
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando      
      this.modelForm = this.dataSourceBody[index];
      //this.reloadListTipoRent();
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }



  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }


  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.distribucionRentasExentasImpAFC();
    //this.distribucionRentasExentasImpPension();
    this.operacionCs700();
    /* this.changeStepLocal(0); */
    this.dialogRef.close("");
  }
  public guardar() {
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_695 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    console.log(this.model.doc.cuerpo)
    this.operacionCs700();
    this.saveModel.emit(true);
    this.closeModal();

  }
  public borrarTabla() {
    this.dataSourceBody = [];
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-rentas-exentas-de-impuesto/beneficios-rentas-exentas-de-impuesto-modal.component.ts